var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./LoadingChatBotResponse.module.scss";
import Spinner from 'react-bootstrap/Spinner';
import { getSettings, getTranslation } from "../../constants/setting";
var LoadingChatBotResponse = function () {
    return _jsxs("div", { children: [_jsx("span", __assign({ style: {
                    padding: '5px 10px'
                }, className: styles.srOnly }, { children: getTranslation('chatbot.response_processing') })), _jsxs("div", __assign({ className: styles.loadingHolder }, { children: [_jsx(Spinner, { animation: "grow", variant: "primary", size: "sm", style: {
                            backgroundColor: getSettings().primary_color
                        } }), _jsx(Spinner, { animation: "grow", variant: "primary", size: "sm", style: {
                            backgroundColor: getSettings().primary_color
                        } }), _jsx(Spinner, { animation: "grow", variant: "primary", size: "sm", style: {
                            backgroundColor: getSettings().primary_color
                        } })] }))] });
};
export default LoadingChatBotResponse;
